import { memo } from 'react';

// Componente de Skeleton para os cards de cursos
const CourseSkeleton = memo(({ showProgressBar = false }) => {
    return (
        <div style={{
            display: 'block',
            width: '100%',
            height: '100%'
        }}>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                backgroundColor: '#f8f9fa',
                borderRadius: '0.375rem',
                overflow: 'hidden',
                boxShadow: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)',
                border: '1px solid #e9ecef'
            }}>
                {/* Skeleton da imagem */}
                <div style={{
                    position: 'relative',
                    width: '100%',
                    height: '200px',
                    backgroundColor: '#e9ecef',
                    overflow: 'hidden'
                }}>
                    <div className="skeleton-shimmer"></div>
                </div>
                
                {/* Skeleton do conteúdo */}
                <div style={{
                    backgroundColor: '#f8f9fa',
                    padding: '0.5rem',
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between'
                }}>
                    {/* Skeleton da barra de progresso (se necessário) */}
                    {showProgressBar && (
                        <div style={{
                            width: '100%',
                            height: '1.5rem',
                            backgroundColor: '#e9ecef',
                            borderRadius: '0.25rem',
                            overflow: 'hidden',
                            marginBottom: '0.5rem',
                            position: 'relative'
                        }}>
                            <div className="skeleton-shimmer"></div>
                        </div>
                    )}

                    {/* Skeleton da data */}
                    <div style={{
                        width: '60%',
                        height: '0.875rem',
                        backgroundColor: '#e9ecef',
                        borderRadius: '0.25rem',
                        marginBottom: '0.5rem',
                        position: 'relative'
                    }}>
                        <div className="skeleton-shimmer"></div>
                    </div>

                    {/* Skeleton do botão */}
                    <div style={{
                        width: '100%',
                        height: '2rem',
                        backgroundColor: '#e9ecef',
                        borderRadius: '0.375rem',
                        position: 'relative'
                    }}>
                        <div className="skeleton-shimmer"></div>
                    </div>
                </div>
            </div>
        </div>
    );
});

CourseSkeleton.displayName = 'CourseSkeleton';

// Componente que renderiza múltiplos skeletons
export const CourseSkeletons = ({ count = 8, showProgressBar = false }) => {
    const skeletons = Array.from({ length: count }, (_, index) => (
        <CourseSkeleton key={`skeleton-${index}`} showProgressBar={showProgressBar} />
    ));

    return <>{skeletons}</>;
};

export default CourseSkeleton;
